export const panelLinkSingle = (
  panelId: string,
  isEditMode: boolean = false
): string => {
  let link = `/panel/${panelId}`;
  if (isEditMode) {
    link += "?mode=edit";
  }
  return link;
};
